export default {
  title: 'Paga con {{method}}',
  hint: 'Successivamente, confermi il pagamento con la tua banca o nella tua app.',
  continue: 'Continua',
  cancel: 'Annulla pagamento',
  unavailable: 'Questo metodo di pagamento non è disponibile al momento. Scegline un altro.',
};
